/* eslint-disable */
import 'jquery.cookie';
import isForbiddenCashBackCountry from '@/js/common/Domain/Service/isForbiddenCashBackCountry';
import LotteryDgView from '@/js/desktop/components/lotteryDg/lotteryDg';
import CashBackDgView from '@/js/desktop/components/cashbackDg/cashbackDg';

import noMirService from '@/js/common/services/noMirService';
import BannerComponent from './Banners';
import Vue from "vue";
import CookieConsentPopup from "@fr/fsd/shared/ui/CookieConsentPopup.vue";
import initSpecialOfferBanner from "@ve/components/banners/specialOfferBanner/initSpecialOfferBanner";
import initGiftCertificatesBanner from "@ve/components/banners/giftCertificates/initGiftCertificatesBanner";


const initBanners = () => {
  if (window.hideBanner) {
    return;
  }

  noMirService('cashbackBanner-closed');
  const isCountryForbidden = isForbiddenCashBackCountry(window.appConfig, document.location);
  const shouldShowCashBackBanner =
    window?.appConfig?.cashbackAvailable && !$.cookie('cashbackBanner-closed') && !isCountryForbidden;

  if (shouldShowCashBackBanner) {
    new CashBackDgView({
      el: '.js-cashback-dg',
      cookieName: 'cashbackBanner-closed',
    });

    return;
  }

  if (/^.*utm_campaign=[^&]*coupon.*$/.test(document.location.search)) {
    new BannerComponent({
      dialogClass: 'takeCouponPopup',
      cookieName: 'takeCouponPopup',
      showConfirmMessage: true,
    });

    return;
  }

  new LotteryDgView({
    el: '.js-lottery-dg',
  });
};

initBanners();

initSpecialOfferBanner();
initGiftCertificatesBanner();

(function initCookieConsentPopup() {
  const mountNode = document.createElement('div');
  document.body.appendChild(mountNode);
  new Vue({
    render: (h) => h(CookieConsentPopup),
  }).$mount(mountNode);
})();
